<mat-toolbar class="content-header">
    <h1 class="page-title">
        <mat-icon>info</mat-icon>
        {{'settings.title' | translate}}
        <!-- <app-help [link]="helpLink" class="helper-margin"></app-help> -->
    </h1>

    <span class="toolbar-spacer"></span>

    <lib-button data-testid="project-save-btn" text="{{'form.save' | translate}}" color="primary" icon="save"
        (click)="editProject()" [disabled]="!hasChanges()" [loading]="loading">
    </lib-button>

    <lib-button *ngIf="project.archived" [icon]="'archive'" [color]="'warning'" [size]="'medium'"
        tooltip="{{ 'projects.archive.undo' | translate }}" (click)="archiveProject()">
    </lib-button>

    <lib-button *ngIf="!project.archived" [icon]="'archive'" [color]="'secondary'" [size]="'medium'"
        tooltip="{{ 'projects.archive.do' | translate }}" (click)="archiveProject()">
    </lib-button>

    <lib-button tooltip="{{'form.delete' | translate}}" color="danger" icon="delete" (click)="deleteProject()">
    </lib-button>
</mat-toolbar>

<div class="info-content">
    <mat-accordion>
        <!-- Project Information -->
        <mat-expansion-panel class="expansion-panel" [expanded]="true">
            <mat-expansion-panel-header class="header-panel">
                <mat-panel-title>
                    <h3>
                        <mat-icon>description</mat-icon>
                        {{ "settings.project.infos" | translate }}
                    </h3>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="panel">
                <div class="panel-row">
                    <div class="image-cards">
                        <div class="label">
                            <mat-icon class="icon">photo_camera</mat-icon>
                            <span>{{ "settings.project.picture.title" | translate }}</span>
                        </div>

                        <app-file-input [image]="project.picture" [accept]="'image/*'" (change)="onFileSelected($event)"
                            (delete)="onDeletePicture()">
                        </app-file-input>

                        <div class="label">
                            <mat-icon class="icon">workspace_premium</mat-icon>
                            <span>{{ "settings.project.logo.title" | translate }}</span>
                        </div>

                        <app-file-input [image]="project.logo" [accept]="'image/*'"
                            (change)="onFileSelected($event, 'logo')" (delete)="onDeleteLogo()">
                        </app-file-input>
                    </div>

                    <div class="description-fields">
                        <div class="badges-row">
                            <div class="badge" matTooltip="{{'datatable.id' | translate}}">
                                <mat-icon>badge</mat-icon>
                                <span class="badge-text">{{ project.id }}</span>
                                <mat-icon class="copy-btn" (click)="copy(project.id)">content_copy</mat-icon>
                            </div>

                            <div class="badge" matTooltip="{{'settings.project.database' | translate}}">
                                <mat-icon>storage</mat-icon>
                                <span class="badge-text">{{ project.database }}</span>
                                <mat-icon class="copy-btn" (click)="copy(project.database)">content_copy</mat-icon>
                            </div>

                            <div class="badge" matTooltip="{{'datatable.createdDate' | translate}}">
                                <mat-icon>event</mat-icon>
                                <span class="badge-text">{{ project.createdDate | timeFormat }}</span>
                            </div>

                            <div class="badge modality-header" [class.active]="modalityEditVisible"
                                (click)="toggleModalityEdit()" *ngIf="isPrivileged()"
                                matTooltip="{{'settings.project.modality' | translate}}">
                                <mat-icon class="icon" matTooltip="{{'settings.project.modality' | translate}}">
                                    {{ getSelectedModality()?.icon }}
                                </mat-icon>

                                <span>{{ getSelectedModality()?.name }}</span>

                                <mat-icon class="dropdown-arrow"
                                    [class.rotated]="modalityEditVisible">expand_more</mat-icon>

                                <div class="modality-options" *ngIf="modalityEditVisible">
                                    <div class="modality-option" *ngFor="let opt of modalityOptions"
                                        [class.selected]="project.modality === opt.value"
                                        (click)="selectModality(opt.value); $event.stopPropagation()">
                                        <mat-icon>{{ opt.icon }}</mat-icon>

                                        <span>{{ opt.name }}</span>

                                        <mat-icon class="check-icon"
                                            *ngIf="project.modality === opt.value">check</mat-icon>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <mat-form-field appearance="outline" class="flex-width" subscriptSizing="dynamic">
                                <mat-label>{{ "settings.project.name" | translate }}</mat-label>
                                <input matInput [(ngModel)]="project.name" name="projectName" />
                            </mat-form-field>
                        </div>

                        <div class="row">
                            <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                <mat-label>{{ "settings.project.reference" | translate }}</mat-label>
                                <input matInput [(ngModel)]="project.reference" name="projectReference" />
                            </mat-form-field>

                            <mat-form-field appearance="outline" *ngIf="isUserAdmin && project"
                                subscriptSizing="dynamic">
                                <mat-label>
                                    {{ "settings.project.type" | translate }}
                                </mat-label>

                                <mat-select [(ngModel)]="project.type" [fixValue]="project.type" name="projectType">
                                    <mat-option value="antico">{{'settings.project.antico'|translate}}</mat-option>
                                    <mat-option value="lean">{{'settings.project.lean'|translate}}</mat-option>
                                    <mat-option value="kyd">{{'settings.project.kyd'|translate}}</mat-option>
                                    <mat-option value="safety">{{'settings.project.safety'|translate}}</mat-option>
                                    <mat-option value="zone">{{'settings.project.zone'|translate}}</mat-option>
                                    <mat-option value="iot">{{'settings.project.iot'|translate}}</mat-option>
                                    <mat-option value="other">{{'settings.project.other'|translate}}</mat-option>
                                    <mat-option value="v2">{{'settings.project.v2'|translate}}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <app-date-picker [label]="'settings.project.endDateProject' | translate"
                                [startDate]="project.endDate" (dateChanged)="onEndDateChanged($event)" [hideTime]="true"
                                [max]="null">
                            </app-date-picker>
                        </div>

                        <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
                            <mat-label>Description</mat-label>
                            <textarea matInput [(ngModel)]="project.description" rows="10"
                                name="projectDescription" data-testid="project-description-input"></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>

        <!-- Location -->
        <mat-expansion-panel class="expansion-panel">
            <mat-expansion-panel-header class="header-panel">
                <mat-panel-title>
                    <h3>
                        <mat-icon>map</mat-icon>
                        {{ "settings.project.location" | translate }}
                    </h3>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="panel location-panel">
                <!-- Street Section -->
                <div class="location-section street">
                    <div class="section-label">
                        <mat-icon>location_on</mat-icon>
                        <span>{{ "settings.project.address" | translate }}</span>
                    </div>

                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-label>
                            {{ "settings.project.street" | translate }}
                        </mat-label>

                        <input matInput [(ngModel)]="project.street" name="projectStreet"
                            (input)="streetInput$.next($event.target.value)" [matAutocomplete]="streetAutocomplete" />

                        <mat-icon matPrefix>edit_location_alt</mat-icon>

                        <mat-autocomplete #streetAutocomplete="matAutocomplete">
                            <mat-option *ngFor="let suggestion of streetSuggestions" [value]="suggestion.description"
                                (onSelectionChange)="onSelectStreet(suggestion)">
                                {{ suggestion.description }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>

                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-label>{{ "language.language" | translate }}</mat-label>
                        <mat-select [(ngModel)]="project.locale" name="projectLanguage">
                            <mat-option value="fr-FR">{{ "language.french" | translate }}</mat-option>
                            <mat-option value="en-US">{{ "language.english" | translate }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- Details Section -->
                <div class="location-section">
                    <div class="section-label">
                        <mat-icon>info</mat-icon>
                        <span>{{ "settings.project.details" | translate }}</span>
                    </div>
                    <div class="form-grid-3">
                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>{{ "settings.project.country" | translate }}</mat-label>
                            <input matInput [(ngModel)]="project.country" name="projectCountry" />
                            <mat-icon matPrefix>public</mat-icon>
                        </mat-form-field>

                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>{{ "settings.project.city" | translate }}</mat-label>
                            <input matInput [(ngModel)]="project.city" name="projectCity" />
                            <mat-icon matPrefix>location_city</mat-icon>
                        </mat-form-field>

                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>{{ "settings.project.zipCode" | translate }}</mat-label>
                            <input matInput [(ngModel)]="project.zipCode" name="projectZipCode" />
                            <mat-icon matPrefix>mail</mat-icon>
                        </mat-form-field>
                    </div>
                </div>

                <!-- Coordinates Section -->
                <div class="location-section">
                    <div class="section-label">
                        <mat-icon>public</mat-icon>
                        <span>{{ "settings.project.coordinates" | translate }}</span>
                    </div>
                    <div class="form-grid-3">
                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>Latitude</mat-label>
                            <input matInput [(ngModel)]="project.lat" step="0.00001" type="number" name="projectLat" />
                            <mat-icon matPrefix>north</mat-icon>
                        </mat-form-field>

                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>Longitude</mat-label>
                            <input matInput [(ngModel)]="project.lon" step="0.00001" type="number" name="projectLon" />
                            <mat-icon matPrefix>east</mat-icon>
                        </mat-form-field>

                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>{{ "settings.project.timezone" | translate }}</mat-label>
                            <mat-select [(ngModel)]="project.timezone" name="projectTimezone">
                                <mat-option *ngFor="let timezone of timezones" [value]="timezone">{{ timezone
                                    }}</mat-option>
                            </mat-select>
                            <mat-icon matPrefix>schedule</mat-icon>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>

        <!-- Schedule -->
        <mat-expansion-panel class="expansion-panel">
            <mat-expansion-panel-header class="header-panel">
                <mat-panel-title>
                    <h3>
                        <mat-icon>watch_later</mat-icon>
                        {{ "units.schedule" | translate }}
                    </h3>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <app-schedule [schedule]="schedule" (scheduleChange)="onScheduleChange($event)">
            </app-schedule>
        </mat-expansion-panel>

        <!-- Metric Models -->
        <mat-expansion-panel class="expansion-panel">
            <mat-expansion-panel-header class="header-panel">
                <mat-panel-title>
                    <h3>
                        <mat-icon>bar_chart</mat-icon>
                        {{ "events.metric_models" | translate }}
                    </h3>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="metrics-container">
                <div class="metric-card" *ngFor="let metric of project.metricModels; let index = index">
                    <div class="metric-header">
                        <mat-icon>bar_chart</mat-icon>
                        <span class="metric-name">{{ metric.name }}</span>
                    </div>

                    <div class="metric-actions">
                        <lib-button icon="edit" color="primary" matTooltip="{{'form.edit' | translate}}"
                            (click)="editMetric(index)">
                        </lib-button>

                        <lib-button icon="save_alt" color="secondary" matTooltip="Export" (click)="exportMetric(index)">
                        </lib-button>

                        <lib-button icon="delete" color="danger" matTooltip="{{'form.delete' | translate}}"
                            (click)="deleteMetric(index)">
                        </lib-button>
                    </div>
                </div>

                <div class="add-metric-card">
                    <lib-button [icon]="'add_circle'" [text]="'settings.project.addTemplate' | translate"
                        (click)="addMetric()">
                    </lib-button>
                </div>
            </div>
        </mat-expansion-panel>

        <!-- Others -->
        <mat-expansion-panel class="expansion-panel" *ngIf="isUserAdmin">
            <mat-expansion-panel-header class="header-panel">
                <mat-panel-title>
                    <h3>
                        <mat-icon>widgets</mat-icon>
                        {{ "settings.project.other" | translate }}
                    </h3>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="panel">
                <div class="row">
                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-label>{{ "settings.project.pixel.title" | translate }}</mat-label>
                        <mat-select [(ngModel)]="project.pixelSize" [fixValue]="project.pixelSize"
                            name="projectPixelSize">
                            <mat-option [value]="1">{{'settings.project.pixel.1'|translate}}</mat-option>
                            <mat-option [value]="2">{{'settings.project.pixel.2'|translate}}</mat-option>
                            <mat-option [value]="3">{{'settings.project.pixel.3'|translate}}</mat-option>
                            <mat-option [value]="4">{{'settings.project.pixel.4'|translate}}</mat-option>
                            <mat-option [value]="5">{{'settings.project.pixel.5'|translate}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-label>
                            {{ "settings.project.starting_page" | translate }}
                        </mat-label>

                        <mat-select [(ngModel)]="project.startingPage" name="projectStartingPage">
                            <mat-option value="home">Home</mat-option>
                            <mat-option value="viewer">Viewer</mat-option>
                            <mat-option value="devices">Devices</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-label>Port NTRIP</mat-label>
                        <input matInput [(ngModel)]="project.portNtrip" name="projectPortNtrip" />
                    </mat-form-field>
                </div>

                <div class="row">
                    <fieldset>
                        <legend>
                            {{ "units.accuracy" | translate }}
                        </legend>

                        <mat-form-field appearance="outline" *ngIf="isUserAdmin" subscriptSizing="dynamic">
                            <mat-label>
                                {{ "settings.project.accuracy.title" | translate }}
                            </mat-label>

                            <mat-select [(ngModel)]="project.geolocation.accuracy"
                                [fixValue]="project.geolocation.accuracy" name="projectGeolocationAccuracy">
                                <mat-option [value]="4">{{"settings.project.accuracy.max" | translate }}</mat-option>
                                <mat-option [value]="5">{{"settings.project.accuracy.ok" | translate }}</mat-option>
                                <mat-option [value]="2">{{"settings.project.accuracy.low" | translate }}</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline" *ngIf="isUserAdmin" subscriptSizing="dynamic">
                            <mat-label>
                                {{ "settings.project.accuracy.duration" | translate }}</mat-label>
                            <input matInput [(ngModel)]="project.geolocation.duration" name="projectGeolocationDuration"
                                step="1" type="number" />
                        </mat-form-field>

                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-label>
                                {{ "units.device.offline_delai" | translate }} (seconds)
                            </mat-label>

                            <input matInput [(ngModel)]="project.offlineDelay" step="1" type="number"
                                name="projectOfflineDelay" />
                        </mat-form-field>
                    </fieldset>
                </div>
            </div>
        </mat-expansion-panel>

        <!-- Admin Settings -->
        <mat-expansion-panel class="expansion-panel" *ngIf="isPrivileged()">
            <mat-expansion-panel-header class="header-panel">
                <mat-panel-title>
                    <h3>
                        <mat-icon>memory</mat-icon>
                        {{ "settings.project.admin" | translate }}
                    </h3>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="panel">
                <div class="row">
                    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="width-40">
                        <mat-label>
                            {{ "settings.project.ia_models" | translate }}
                        </mat-label>

                        <mat-select (selectionChange)="onAiModulesChange($event)" [(ngModel)]="selectedAIModules"
                            multiple>
                            <mat-select-trigger>
                                {{ getSelectedModuleNames() }}
                            </mat-select-trigger>

                            @for(labelProject of labelProjects; track labelProject.name) {
                            <mat-option [value]="labelProject.name" class="option-row">
                                <span class="project-name">
                                    {{ labelProject.displayName }}
                                </span>

                                <mat-button-toggle-group *ngIf="labelProject.iterations.length > 1"
                                    class="iteration-group" name="{{labelProject.name}}-iterations"
                                    [value]="selectedIterations[labelProject.name]"
                                    (change)="selectIteration(labelProject.name, $event.value)"
                                    [hideSingleSelectionIndicator]="true" exclusive>

                                    <mat-button-toggle *ngFor="let iteration of labelProject.iterations"
                                        (click)="iterationClick($event, labelProject.name)" [value]="iteration">
                                        {{ iteration }}
                                    </mat-button-toggle>

                                </mat-button-toggle-group>
                            </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-label>
                            {{ "settings.project.database" | translate }}
                        </mat-label>

                        <mat-select [(ngModel)]="project.services.database" name="projectDatabase">
                            <mat-option value="dbProd">Prod</mat-option>
                            <mat-option value="dbProd2">Prod 2</mat-option>
                            <mat-option value="dbDev">Dev</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <!-- <div style="display: flex">
                  <mat-form-field appearance="outline">
                    <mat-label>Flow Realtime</mat-label>
                    <mat-select formControlName="flowRealtime">
                      <mat-option value="https://unifield-flow-realtime.azurewebsites.net">Prod</mat-option>
                      <mat-option value="https://unifield-flow-2.azurewebsites.net">Prod 2</mat-option>
                      <mat-option value="https://unifield-flow-realtime-dev.azurewebsites.net">Dev</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Flow Replay</mat-label>
                    <mat-select formControlName="flowReplay">
                      <mat-option value="https://unifield-flow-replay.azurewebsites.net">Prod</mat-option>
                      <mat-option value="https://unifield-flow-replay-dev.azurewebsites.net">Dev</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Flow Port (42XXX)</mat-label>
                    <input matInput formControlName="flowPort" type="number" min="42000" max="42999" />
                  </mat-form-field>
                </div> -->

                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-label>
                            {{ "projects.datavizTabs" | translate }}
                        </mat-label>

                        <mat-select [ngModel]="selectedTabs" (ngModelChange)="onTabsChange($event)"
                            [fixValue]="selectedTabs" multiple name="projectAllTabs">
                            <mat-option *ngFor="let tab of tabOptions" [value]="tab.value">
                                {{ tab.label | translate }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-label>{{ "risks.risk_report" | translate }}</mat-label>
                        <mat-select [(ngModel)]="riskReportParams" name="reportParams" multiple>
                            <mat-option value="description">{{ "form.description" | translate }}</mat-option>
                            <mat-option value="zone">{{ "risks.zone" | translate }}</mat-option>
                            <mat-option value="sequence">{{ "risks.sequence" | translate }}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="width-40">
                        <mat-label>
                            {{ "settings.project.streamLimit.title" | translate }}
                        </mat-label>

                        <input matInput [(ngModel)]="streamDailyLimitMinutes" min="0" step="1" type="number"
                            name="projectStreamDailyLimit" />
                    </mat-form-field>

                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-label>
                            {{ "settings.project.mediaServer.title" | translate }}
                        </mat-label>

                        <mat-select [(ngModel)]="project.services.mediaServer" name="projectMediaServer">
                            <mat-option value="prod">Prod</mat-option>
                            <mat-option value="dev">Dev</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="flow-url">
                        <mat-label>
                            {{ "settings.project.flowUrl" | translate }}
                        </mat-label>

                        <input matInput [(ngModel)]="project.services.flowRealtime" name="projectFlowRealtime"
                            type="url" autocomplete="off" placeholder="https://" />
                    </mat-form-field>

                    <div class="row">
                        <span>{{ "projects.reports.activation" | translate }}</span>

                        <mat-slide-toggle [(ngModel)]="project.reportsEnabled"
                            (change)="project.reportsEnabled = $event.checked">
                            {{(project.reportsEnabled ? 'status.active' : 'status.inactive') | translate }}
                        </mat-slide-toggle>
                    </div>
                </div>

                <fieldset>
                    <legend>
                        {{ "settings.project.nelia.title" | translate }}
                    </legend>

                    <mat-slide-toggle [(ngModel)]="project.nelia.enabled" name="neliaEnabled">
                        {{(project.nelia && project.nelia.enabled ? "status.active" : "status.inactive" ) | translate}}
                    </mat-slide-toggle>

                    <mat-slide-toggle [(ngModel)]="project.nelia.realtime">
                        {{ "workflows.realtime" | translate }}
                    </mat-slide-toggle>

                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-label>
                            {{ "projects.report_time" | translate }}
                        </mat-label>

                        <input matInput [format]="24" [ngxTimepicker]="reportTimePicker"
                            [value]="project.nelia.reportTime" readonly class="time-picker" />

                        <ngx-material-timepicker #reportTimePicker (timeSet)="onReportTimeChanged($event)">
                        </ngx-material-timepicker>
                    </mat-form-field>

                    <!-- <app-date-picker [label]="'settings.project.reportTime' | translate"
                        [startDate]="project.nelia.reportTime" (dateChanged)="onReportTimeChanged($event)"
                        [hideTime]="true" class="date-picker">
                    </app-date-picker> -->

                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-label>
                            {{ "trackers.title" | translate }}
                        </mat-label>

                        <mat-select [(ngModel)]="project.nelia.trackers" name="neliaTrackers" multiple>
                            <mat-option *ngFor="let tracker of trackers" [value]="tracker.id">
                                {{tracker.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </fieldset>

                <fieldset>
                    <legend>
                        {{ "enlaps.title" | translate }}
                    </legend>

                    <mat-slide-toggle [(ngModel)]="project.enlaps.enabled">
                        {{(project.enlaps && project.enlaps.enabled ? "status.active" : "status.inactive" ) |
                        translate}}
                    </mat-slide-toggle>

                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-label>
                            {{ "enlaps.url" | translate }}
                        </mat-label>

                        <input matInput placeholder="Placeholder" [(ngModel)]="project.enlaps.url"
                            name="projectEnlapsUrl" />
                    </mat-form-field>
                </fieldset>

                @if(project.transfer && project.transfer.messages?.length && project.transfer.status != 'inactive')
                {
                <fieldset class="services" *ngIf="isPrivileged() && project.services?.database != 'dbDev'">
                    <legend>
                        {{ "settings.project.transfer.title" | translate }}
                    </legend>



                    <div class="transfer-div">
                        <table>
                            <thead>
                                <tr>
                                    <th>
                                        <div class="div-th">
                                            <mat-icon class="icon">autorenew</mat-icon>
                                            {{ "units.status" | translate }}
                                        </div>
                                    </th>

                                    <th>
                                        <div class="div-th">
                                            <mat-icon class="icon">toggle_on</mat-icon>
                                            {{ "settings.project.transfer.activate" | translate }}
                                        </div>
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr>
                                    <td class="width-50">
                                        <div *ngIf="project.transfer.status == 'inactive'">
                                            {{ "settings.project.transfer.inactive" | translate }}
                                        </div>

                                        <div *ngIf="project.transfer.status == 'cloning'">
                                            {{ "settings.project.transfer.cloning" | translate }}
                                        </div>

                                        <div *ngIf="project.transfer.status == 'cloned'">
                                            {{ "settings.project.transfer.cloned" | translate }}
                                        </div>

                                        <div *ngIf="project.transfer.status == 'failed'">
                                            {{ "settings.project.transfer.failed" | translate }}
                                        </div>

                                        <div *ngIf="project.transfer.status == 'stopped'">
                                            {{ "settings.project.transfer.stopped" | translate }}
                                        </div>

                                        <div *ngIf="project.transfer.status == 'paused'">
                                            {{ "settings.project.transfer.paused" | translate }}
                                        </div>

                                        <div *ngIf="project.transfer.status == 'active'">
                                            {{ "settings.project.transfer.active" | translate }}
                                        </div>
                                    </td>

                                    <td class="width-50">
                                        <mat-slide-toggle [(ngModel)]="project.transfer.enabled" [disabled]="false">
                                        </mat-slide-toggle>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div class="transfer-messages {{ project.transfer.status }}"
                            [ngClass]="{dangedr: project.transfer.status == 'failed', sucdcess: project.transfer.status == 'active' || project.transfer.status == 'cloned'}">
                            <div *ngFor="let message of project.transfer.messages">
                                {{ message }}
                            </div>
                        </div>
                    </div>
                </fieldset>
                }
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</div>